<template>
  <div class="footer-main">
    <div v-if="$route.path != '/About'" class="contact-content p-relative">
      <img class="w-100" src="@/assets/images/footer/contact-en.png" alt="" />
      <div class="contact-main p-absolute">
        <h2>
          {{ $t('message.footer.title') }}
        </h2>
        <el-button type="primary" @click="handleContact">
          {{ $t('message.footer.contactBtn') }}
        </el-button>
      </div>
    </div>
    <div class="footer-component" :class="$route.path == '/About' ? 'pt0' : ''">
      <div v-if="$route.path != '/About'" class="footer-top d-flex">
        <div class="left">
          <div class="logo-wrap">
            <img src="@/assets/images/footer/logo-footer.svg" alt="" />
          </div>
          <p>
            {{ $t('message.footer.slogan') }}
          </p>
          <div class="link-wrap d-flex">
            <img class="link-item cursor-pointer" @click="jumpRoute2('https://mp.weixin.qq.com/s/BswPfEEgpv9I-rWUgZSxlQ')" src="@/assets/images/footer/link1.svg" alt="" />
            <img class="link-item cursor-pointer" @click="jumpRoute2('https://author.baidu.com/home?from=bjh_article&app_id=1864687776853084')" src="@/assets/images/footer/link2.svg" alt="" />
            <img class="link-item cursor-pointer" @click="jumpRoute2('https://www.zhihu.com/org/tblhua-qing-ke-sheng-79/posts')" src="@/assets/images/footer/link3.svg" alt="" />
            <img class="link-item cursor-pointer" @click="jumpRoute2('https://www.linkedin.com/company/techbloom-beijing-information-technology-co-ltd/')" src="@/assets/images/footer/link4.svg" alt="" />
            <img class="link-item cursor-pointer" @click="jumpRoute2('https://www.facebook.com/profile.php?id=61589862447197')" src="@/assets/images/footer/link5.svg" alt="" />
            <img class="link-item cursor-pointer" @click="jumpRoute2('https://www.youtube.com/@Techbloom-TBL-Global')" src="@/assets/images/footer/link6.svg" alt="" />
          </div>
        </div>
        <div class="center">
          <el-row :gutter="20">
            <el-col :span="8" class="product-col">
              <div class="product-wrap">
                <h3 class="type-title">
                  {{ $t('message.footer.label1') }}
                </h3>
                <div class="page-list">
                  <div class="page-item" v-for="(item, index) in softwareProduct" :key="index" @click="jumpRoute(item.route)">
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="product-wrap">
                <h3 class="type-title mt">
                  {{ $t('message.footer.label2') }}
                </h3>
                <div class="page-list">
                  <div class="page-item" v-for="(item, index) in hardwareProduct" :key="index" @click="jumpRoute(item.route)">
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="16">
              <h3 class="type-title scene-title">
                {{ $t('message.footer.label4') }}
              </h3>
              <el-row :gutter="$store.state.screenWidth > 768 ? 20 : 0">
                <el-col :span="12">
                  <div class="page-list">
                    <div class="page-item" v-for="(item, index) in sceneData.slice(0, 8)" :key="index" @click="jumpRoute(item.route)">
                      {{ item.name }}
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="page-list">
                    <div class="page-item" v-for="(item, index) in sceneData.slice(8, 15)" :key="index" @click="jumpRoute(item.route)">
                      {{ item.name }}
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="second-row" :gutter="$store.state.screenWidth > 768 ? 20 : 0">
            <el-col :span="16">
              <h3 class="type-title">
                {{ $t('message.footer.label3') }}
              </h3>
              <el-row :gutter="$store.state.screenWidth > 768 ? 20 : 0">
                <el-col :span="12">
                  <div class="page-list">
                    <div class="page-item" v-for="(item, index) in iotProduct.slice(0, 6)" :key="index" @click="jumpRoute(item.route)">
                      {{ item.name }}
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="page-list">
                    <div class="page-item" v-for="(item, index) in iotProduct.slice(6, 12)" :key="index" @click="jumpRoute(item.route)">
                      {{ item.name }}
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <h3 class="type-title special link" @click="jumpRoute('/Vehicle_Industry')">
                {{ $t('message.footer.label5') }}
              </h3>
              <h3 class="type-title special link" @click="jumpRoute('/About')">
                {{ $t('message.footer.label6') }}
              </h3>
              <h3 class="type-title special link" @click="jumpRoute('/Contact')">
                {{ $t('message.footer.contactUs') }}
              </h3>
            </el-col>
          </el-row>
        </div>
        <div class="right">
          <div class="right-title">
            {{ $t('message.footer.contactUs') }}
          </div>
          <div class="right-list">
            <div class="right-item">
              <div class="left-icon">
                <img src="@/assets/images/footer/phone.svg" alt="" />
              </div>
              <div class="right-content">
                <p>
                  {{ $t('message.footer.hotline') }}
                </p>
                <div class="phone">
                  +86 400-0667-887
                </div>
              </div>
            </div>

            <div class="right-item">
              <div class="left-icon">
                <img src="@/assets/images/footer/email.svg" alt="" />
              </div>
              <div class="right-content">
                <p>
                  marketing@techbloom.net
                </p>
              </div>
            </div>

            <div class="right-item">
              <div class="left-icon">
                <img src="@/assets/images/footer/locate.svg" alt="" />
              </div>
              <div class="right-content">
                <p v-html="$t('message.footer.address')"></p>
                <p v-html="$t('message.footer.address2')" class="addr"></p>
              </div>
            </div>
          </div>
          <div class="right-bottom">
            <div class="left-code">
              <img src="@/assets/images/footer/qrcode.svg" alt="" />
            </div>
            <div class="right-main">
              <h4>
                {{ $t('message.footer.msg1') }}
              </h4>
              <p>
                {{ $t('message.footer.msg2') }}
              </p>
              <el-button type="text" @click="jumpRoute('/Contact')">
                <i class="el-icon-right"></i>
                {{ $t('message.footer.more') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="copyright">
          Copyright © TBL华清科盛公司All Rights Reserved
        </div>
        <div class="bottom-right d-flex justify-content-between">
          <div class="d-flex">
            <div>
              {{ $t('message.privacyPolicy') }}
            </div>
            <div>
              {{ $t('message.terms') }}
            </div>
            <div>
              网站许可证：京ICP备12035150号-2
            </div>
          </div>
          <div>
            {{ $t('message.systemWorking') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {
    currentLang: {
      type: String,
      default: 'cn',
    },
  },
  inject: ['handleContact'],
  data() {
    return {
      softwareProduct: [
        {
          name: this.$t('message.header.productLabel1'),
          route: '/Wisdom_AI_Applications',
        },
        {
          name: this.$t('message.header.productLabel2'),
          route: '/Wisdom_BI_Analysis',
        },
        {
          name: this.$t('message.header.productLabel3'),
          route: '/Business_Manage_System',
        },
        {
          name: this.$t('message.header.productLabel4'),
          route: '/Intelligent_Device_Management_Platform',
        },
      ],
      hardwareProduct: [
        {
          name: this.$t('message.header.productLabel5'),
          route: '/Automation',
        },
        {
          name: this.$t('message.header.productLabel6'),
          route: '/AI_Robot',
        },
        {
          name: this.$t('message.header.productLabel18'),
          route: '/Follow_Robot',
        },
      ],
      iotProduct: [
        {
          name: this.$t('message.header.productLabel16'),
          route: '/Information_Perception_Devices',
        },
        {
          name: this.$t('message.header.productLabel17'),
          route: '/Error_Proofing_Prompt_Devices',
        },
        {
          name: this.$t('message.header.productLabel7'),
          route: '/Wearable_Devices',
        },
        {
          name: this.$t('message.header.productLabel8'),
          route: '/Self_Collect_Devices',
        },
        {
          name: this.$t('message.header.productLabel9'),
          route: '/High_Precision_Positioning_Devices',
        },
        {
          name: this.$t('message.header.productLabel10'),
          route: '/Display_Updated_Devices',
        },
        {
          name: this.$t('message.header.productLabel11'),
          route: '/Quick_Inventory_Scanning_Devices',
        },
        // {
        //   name: '智能亮灯指引设备',
        //   route: '/Lighting_Guidance_Devices',
        // },
        {
          name: this.$t('message.header.productLabel13'),
          route: '/Unattended_Devices',
        },
        {
          name: this.$t('message.header.productLabel14'),
          route: '/Tool_Circulation_Track_Devices',
        },
        {
          name: this.$t('message.header.productLabel15'),
          route: '/Quick_Call_Devices',
        },
        {
          name: this.$t('message.header.productLabel19'),
          route: '/Safety_Protection_Devices',
        },
        {
          name: this.$t('message.header.productLabel20'),
          route: '/Baggage_Identification_Devices',
        },
      ],
      sceneData: [
        {
          name: this.$t('message.header.sceneLabel1'),
          route: '/Supply_Chain_Manage',
        },
        {
          name: this.$t('message.header.sceneLabel2'),
          route: '/Material_External_Warehouse_Manage',
        },
        {
          name: this.$t('message.header.sceneLabel3'),
          route: '/Park_Manage',
        },
        {
          name: this.$t('message.header.sceneLabel4'),
          route: '/Platform_Manage',
        },
        {
          name: this.$t('message.header.sceneLabel5'),
          route: '/Loading_and_Unloading_Vehicle_Storage',
        },
        {
          name: this.$t('message.header.sceneLabel10'),
          route: '/Finished_Product_Storage_and_Tallying',
        },
        {
          name: this.$t('message.header.sceneLabel9'),
          route: '/Order_Picking',
        },
        {
          name: this.$t('message.header.sceneLabel8'),
          route: '/Delivery_Transport',
        },
        {
          name: this.$t('message.header.sceneLabel7'),
          route: '/Finished_Product_External_Warehouse_Manage',
        },
        {
          name: this.$t('message.header.sceneLabel6'),
          route: '/Production_Process_Data_Manage',
        },
        {
          name: this.$t('message.header.sceneLabel11'),
          route: '/Operational_Standard_Manage',
        },
        {
          name: this.$t('message.header.sceneLabel12'),
          route: '/Device_Inspection_Maintenance_Manage',
        },
        {
          name: this.$t('message.header.sceneLabel13'),
          route: '/Property_Manage',
        },
        {
          name: this.$t('message.header.sceneLabel14'),
          route: '/Staff_Manage',
        },
        {
          name: this.$t('message.header.sceneLabel15'),
          route: '/Vehicle_Manage',
        },
      ],
    };
  },
  mounted() {},
  methods: {
    jumpRoute(route) {
      this.$router.push(route);
      window.scrollTo(0, 0);
    },
    jumpRoute2(data) {
      window.location.href = data;
    }
  },
};
</script>

<style lang="scss" scoped>
// .footer-main {
//   margin-top: 30px;
// }
.contact-content {
  .contact-main {
    top: 50%;
    left: 272px;
    transform: translateY(-50%);
    h2 {
      color: #010d39;
      font-size: 32px;
      font-weight: 400;
      line-height: 40px;
      margin-bottom: 25px;
    }
    .el-button {
      width: 138px;
      height: 40px;
      border-radius: 13px;
      font-size: 16px;
      color: #fff;
      background-color: #1a65ff;
    }
  }
}
.en-container {
  .contact-content {
    .contact-main {
      .el-button {
        width: auto;
      }
    }
  }
}
.footer-component {
  padding: 81px 272px 36px;
  border-top: 1px solid #e0dfdf;
  &.pt0 {
    padding-top: 0;
  }
  .footer-top {
    border-bottom: 1px solid #e0dfdf;
    padding-bottom: 75px;
    .left {
      width: 296px;
      margin-right: 58px;
      .logo-wrap {
        img {
          width: 130px;
        }
      }
      p {
        margin-top: 32px;
        color: #7f7f7f;
        font-size: 14px;
        line-height: 23px;
      }
      .link-wrap {
        margin-top: 31px;
        justify-content: space-around;
        img {
          width: 39px;
        }
      }
    }
    .center {
      width: 799px;
      .second-row {
        margin-top: 45px;
      }
      .type-title {
        cursor: pointer;
        color: #202020;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        transition: color 0.3s;
        user-select: none;
        &.link {
          cursor: pointer;
          transition: color 0.3s;
          user-select: none;
          &:hover {
            color: #1867ff;
          }
        }
        &.mt {
          margin-top: 28px;
        }
      }
      .page-list {
        .page-item {
          cursor: pointer;
          font-size: 14px;
          color: #7f7f7f;
          line-height: 1.4;
          margin-bottom: 10px;
          transition: color 0.3s;
          user-select: none;
          &:hover {
            color: #1867ff;
          }
        }
      }
    }
    .right {
      width: 281px;
      .right-title {
        color: #202020;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
      }
      .right-list {
        border-bottom: 1px solid #e0dfdf;
        padding-bottom: 25px;
        .right-item {
          display: flex;
          margin-bottom: 16px;
          .left-icon {
            width: 20px;
            margin-right: 12px;
            img {
              width: 20px;
            }
          }
          .right-content {
            padding-top: 3px;
            p {
              color: #7f7f7f;
              font-size: 14px;
              line-height: 20px;
              &.addr {
                margin-top: 24px;
              }
            }
            .phone {
              color: #202020;
              font-size: 20px;
              line-height: 28px;
              font-weight: 500;
            }
          }
        }
      }
      .right-bottom {
        margin-top: 21px;
        display: flex;
        align-items: center;
        .left-code {
          img {
            width: 98px;
          }
        }
        .right-main {
          margin-left: 15px;
          h4 {
            color: #202020;
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
          }
          p {
            margin-top: 6px;
            color: #7f7f7f;
            font-size: 12px;
            line-height: 16px;
          }
          .el-button {
            color: #1a64ff;
            font-size: 12px;
            padding-bottom: 0;
          }
        }
      }
    }
  }
  .footer-bottom {
    padding: 33px 0;
    display: flex;
    div {
      color: #7f7f7f;
      font-size: 14px;
      line-height: 20px;
    }
    .copyright {
      width: 346px;
    }
    .bottom-right {
      width: calc(100% - 346px);
      > div {
        gap: 22px;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .footer-main {
    .contact-content {
      height: 360px;
      img {
        height: 100%;
      }
      .contact-main {
        left: 60px;
        h2 {
          font-size: 62px;
          line-height: 68px;
          margin-bottom: 45px;
        }
        .el-button {
          // width: 238px;
          height: 80px;
          border-radius: 25px;
          font-size: 32px;
        }
      }
    }
    .footer-component {
      padding: 60px;
      .footer-top {
        display: block !important;
        .left {
          width: 100%;
          margin-right: 0;
          .logo-wrap {
            img {
              width: 360px;
            }
          }
          p {
            margin-top: 32px;
            font-size: 46px;
            line-height: 62px;
          }
          .link-wrap {
            margin-top: 31px;
            justify-content: start;
            gap: 32px;
            img {
              width: 105px;
            }
          }
        }
        .center {
          width: 100%;
          margin-top: 35px;
          .second-row {
            margin-top: 45px;
          }
          .el-col-8,
          .el-col-16 {
            width: 100%;
          }
          .product-col {
            display: flex;
            .product-wrap {
              width: 50%;
            }
          }
          .scene-title {
            margin-top: 45px;
          }
          .type-title {
            margin-bottom: 26px;
            font-size: 52px;
            line-height: 58px;
            &.mt {
              margin-top: 0;
            }
            &.special {
              margin-top: 75px;
            }
          }
          .page-list {
            .page-item {
              padding-right: 35px;
              font-size: 42px;
              // line-height: 78px;
              margin-bottom: 25px;
            }
          }
        }
        .right {
          width: 100%;
          .right-title {
            margin-bottom: 26px;
            font-size: 52px;
            line-height: 64px;
            margin-top: 56px;
          }
          .right-list {
            border-bottom: 1px solid #e0dfdf;
            padding-bottom: 25px;
            display: flex;
            flex-wrap: wrap;
            .right-item {
              display: flex;
              margin-bottom: 26px;
              margin-top: 26px;
              width: 50%;
              .left-icon {
                width: 72px;
                img {
                  width: 60px;
                }
              }
              .right-content {
                padding-top: 3px;
                p {
                  font-size: 34px;
                  line-height: 50px;
                  &.addr {
                    margin-top: 24px;
                  }
                }
                .phone {
                  margin-top: 26px;
                  font-size: 60px;
                  line-height: 48px;
                }
              }
            }
          }
          .right-bottom {
            margin-top: 31px;
            .left-code {
              img {
                width: 198px;
              }
            }
            .right-main {
              margin-left: 25px;
              h4 {
                font-size: 48px;
                line-height: 50px;
              }
              p {
                margin-top: 16px;
                font-size: 32px;
                line-height: 36px;
              }
              .el-button {
                font-size: 32px;
                padding-bottom: 0;
              }
            }
          }
        }
      }
      .footer-bottom {
        padding-top: 33px;
        display: block;
        div {
          font-size: 34px;
          line-height: 50px;
        }
        .copyright {
          width: 100%;
        }
        .bottom-right {
          width: 100%;
          margin-top: 50px;
          > div {
            gap: 52px;
          }
        }
      }
    }
  }
}
</style>
